import { createFileRoute } from '@tanstack/react-router';
import { ContactsDirectory } from '@/components/finance/contacts';

// Contacts is a first-class primary tab now (it's working data, not
// configuration), so the canonical list mounts here at the top level. The old
// settings/contacts URLs redirect here so existing bookmarks keep working.
export const Route = createFileRoute('/admin/finance/contacts/')({
  validateSearch: (search: Record<string, unknown>): {
    // Report-detail "Fix Issues" deep-link: scopes the directory back to
    // the originating report and surfaces a "Back to report" affordance.
    returnTo?: 'report';
    reportId?: string;
  } => ({
    returnTo: search.returnTo === 'report' ? 'report' : undefined,
    reportId: typeof search.reportId === 'string' ? search.reportId : undefined,
  }),
  component: ContactsDirectory,
});
